/**
 * TOCの展開機能
 *
 * @param {string} selector - TOCのセレクタ（デフォルトは'#toc_container'）
 */
export function expandableToc(selector = '#toc_container') {
	const toc = document.querySelector(selector);
	if (!toc) return;

	// 初期状態の高さとスタイル
	toc.style.height = '240px';
	toc.style.overflow = 'hidden';
	toc.style.position = 'relative';

	// 展開ボタンの作成
	const button = document.createElement('div');
	button.className = 'js-toc-container-button';
	button.textContent = 'もっと見る';
	toc.appendChild(button);

	button.addEventListener('click', () => {
		// ボタンを削除
		button.remove();

		// 高さをアニメーション付きで展開（slideDown風）
		const startHeight = toc.offsetHeight;
		toc.style.height = startHeight + 'px';
		toc.style.overflow = 'hidden';

		// 一時的に height: auto を使って最終高さを取得
		toc.style.transition = 'none';
		toc.style.height = 'auto';
		const endHeight = toc.offsetHeight;

		// 再設定してからトリガー
		toc.style.height = startHeight + 'px';
		toc.offsetHeight; // 強制リフロー

		// アニメーションスタイル適用
		toc.style.transition = 'height 0.4s ease';
		toc.style.height = endHeight + 'px';

		// アニメーション完了後に height をリセット（autoに）
		toc.addEventListener(
			'transitionend',
			function handler() {
				toc.style.height = '';
				toc.style.overflow = '';
				toc.style.transition = '';
				toc.removeEventListener('transitionend', handler);
			}
		);
	});
}
